module.exports = __webpack_public_path__ + "assets/img/20_1052_big.80567745.jpg";